import { render, staticRenderFns } from "./brand-column.vue?vue&type=template&id=45c09425&scoped=true"
import script from "./brand-column.vue?vue&type=script&lang=js"
export * from "./brand-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c09425",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c09425')) {
      api.createRecord('45c09425', component.options)
    } else {
      api.reload('45c09425', component.options)
    }
    module.hot.accept("./brand-column.vue?vue&type=template&id=45c09425&scoped=true", function () {
      api.rerender('45c09425', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/approved-message/columns/brand-column.vue"
export default component.exports